export default {
    data: [],
    fetched: false,
    serialNumber: '',
    certName: '',
    ipAddr: '',
};